import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FiltroConsultaMicroempresarios } from '../Model/filtroConsultaMicroempresarios';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
@Injectable({
  providedIn: 'root',
})
export class ConsultaMicroempresariosService {
  public url: string;

  constructor(private http: HttpClient) {
    this.url = environment.apiLocalUrl + 'intermediarioFinanciero/services/consultas/solicitudesIntermediario/';
  }

  consultarMicroempresarioFiltro(
    filtrosConsulta: FiltroConsultaMicroempresarios
  ): Observable<any[]> {
    const headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post<any[]>(`${this.url}respuestasMicroempresarios`, filtrosConsulta, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  consultarHistoricoFiltro(
    filtrosConsulta: FiltroConsultaMicroempresarios
  ): Observable<any[]> {
    const headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post<any[]>(`${this.url}respuestasCliente`, filtrosConsulta, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  getEstadosIntermediario(): Observable<any> {
    return this.http.get(environment.apiLocalUrl + 'neoEstadoSolicitud/' );
  }

  generarReporteCliente(
    filtrosConsulta: FiltroConsultaMicroempresarios
  ): Observable<any[]> {
    const headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post<any[]>(`${this.url}respuestasCliente/reporte`, filtrosConsulta, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }
  generarReporteMicroempresario(
    filtrosConsulta: FiltroConsultaMicroempresarios
  ): Observable<any[]> {
    const headers = new HttpHeaders().set('Content-type', 'application/json');

    return this.http.post<any[]>(`${this.url}respuestasMicroempresarios/reporte`, filtrosConsulta, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }
}
